import React, { useState, useEffect } from 'react';
import { CheckCircle2, AlertCircle, Info, X } from 'lucide-react';
import { TOAST_EVENT } from '../utils/toast';

const ICONS = {
  success: <CheckCircle2 size={16} style={{ color: '#10b981', flexShrink: 0, marginTop: 1 }} />,
  error: <AlertCircle size={16} style={{ color: '#ef4444', flexShrink: 0, marginTop: 1 }} />,
  info: <Info size={16} style={{ color: '#6366f1', flexShrink: 0, marginTop: 1 }} />,
};

const BORDER_COLORS = {
  success: '#d1fae5',
  error: '#fee2e2',
  info: '#e0e7ff',
};

export default function Toaster() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const handler = (e) => {
      const id = Date.now() + Math.random();
      setToasts((prev) => [...prev, { id, ...e.detail }]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, 3500);
    };
    window.addEventListener(TOAST_EVENT, handler);
    return () => window.removeEventListener(TOAST_EVENT, handler);
  }, []);

  if (!toasts.length) return null;

  return (
    <div style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 9999, display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 360, pointerEvents: 'none' }}>
      {toasts.map((t) => (
        <div
          key={t.id}
          style={{
            display: 'flex', alignItems: 'flex-start', gap: 10,
            padding: '12px 16px', background: '#fff', borderRadius: 10,
            boxShadow: '0 4px 24px rgba(0,0,0,0.15)',
            border: `1px solid ${BORDER_COLORS[t.type] || '#e4e4e7'}`,
            minWidth: 240, pointerEvents: 'auto',
            animation: 'fadeIn 0.2s ease-out',
          }}
        >
          {ICONS[t.type]}
          <span style={{ fontSize: 13, fontWeight: 600, color: '#09090b', flex: 1, lineHeight: 1.4 }}>{t.message}</span>
          <button
            onClick={() => setToasts((prev) => prev.filter((x) => x.id !== t.id))}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, color: '#9ca3af', flexShrink: 0 }}
            aria-label="Dismiss"
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
